module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/bold-download-5251e73fc72940834e44b9f8b21c4b81.png";